import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'react-sidebar';

import SidebarContent from '../../common/sidebar/SidebarContent';
import useSidebar from '../../common/sidebar/useSidebar';

import AdminHeader from './AdminHeader';
import { getDesktopSidebarStyles } from '../../../utils/sidebar-utils';

const AdminPageContainer = props => {
  const { isSidebarOpen, setIsSidebarOpen, openSidebar, closeSidebar } = useSidebar();
  return (
    <Sidebar
      open={isSidebarOpen}
      onSetOpen={setIsSidebarOpen}
      sidebar={<SidebarContent closeSidebar={closeSidebar} />}
      styles={getDesktopSidebarStyles()}
    >
      <AdminHeader openSidebar={openSidebar} />
      <div className="tutorium-container pt-100px">{props.children}</div>
    </Sidebar>
  );
};

AdminPageContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminPageContainer;
